import React, { useEffect, useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Button,
  List,
  ListItem,
  ListItemAvatar,
  Avatar,
  ListItemText,
  CircularProgress,
  Box,
} from "@material-ui/core";
import api from "../services/api";
import { toast } from "react-toastify";
import ContactModal from "../components/ContactModal";

export default function SelectContactModal({ open, onClose, onSelected }) {
  const [contatos, setContatos] = useState([]);
  const [filtro, setFiltro] = useState("");

  const [loading, setLoading] = useState(false);
  const [abrindo, setAbrindo] = useState(false);

  // 🔹 Modal de criação
  const [modalCriarAberto, setModalCriarAberto] = useState(false);
  const [novoContato, setNovoContato] = useState({ nome: "", telefone: "" });

  const normalizar = (str = "") =>
    str.normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase();

  useEffect(() => {
    if (open) carregarContatos();
  }, [open]);

  const carregarContatos = async () => {
    setLoading(true);
    try {
      const { data } = await api.get("/contacts");
      setContatos(data.data || []);
    } catch {
      toast.error("Erro ao carregar contatos");
    } finally {
      setLoading(false);
    }
  };

  const filtrar = (c) => {
    const termo = normalizar(filtro.trim());
    if (!termo) return true;

    const nome = normalizar(c.nome || "");
    const numero = (c.telefone || "").replace(/\D/g, "");

    return nome.includes(termo) || numero.includes(termo);
  };

  const abrirAtendimento = async (contato) => {
    setAbrindo(true);
    try {
      const tel = contato.telefone.replace(/\D/g, "");

      // 🔍 1) Verificar se o número tem WhatsApp
      const { data: check } = await api.post("/user/check", { Phone: [tel] });
      const users = check?.data?.Users || check?.Users || [];
      const isInWhatsapp = users[0]?.IsInWhatsapp === true;

      if (!isInWhatsapp) {
        toast.error("❌ Este número não possui WhatsApp ativo.");
        setAbrindo(false);
        return;
      }

      // 🔥 2) Abre o chat ou reabre
      const { data: resp } = await api.post("/chat/reabrir", {
        telefone: tel,
        nome: contato.nome,
      });

      if (resp.success) {
        toast.success("Atendimento iniciado!");

        if (window.onChatCreatedGlobal) {
          window.onChatCreatedGlobal(resp.data);
        }

        onSelected && onSelected(resp.data);
        onClose && onClose();
      } else {
        toast.error("Erro ao abrir atendimento.");
      }
    } catch {
      toast.error("Erro ao abrir atendimento.");
    } finally {
      setAbrindo(false);
    }
  };

  // 🔹 Abrir modal de criação quando não encontrar contato
  const abrirCriacaoContato = () => {
    const telefoneLimpo = filtro.replace(/\D/g, "");

    setNovoContato({
      nome: filtro.length > 10 ? filtro : "",
      telefone: telefoneLimpo,
    });

    setModalCriarAberto(true);
  };

  // 🔹 Quando salvar contato no modal
  const handleSalvarContato = async (dados) => {
    try {
      const tel = dados.telefone.replace(/\D/g, "");

      // 🔍 1) Verifica se o número tem WhatsApp ANTES DE CRIAR
      const { data: check } = await api.post("/user/check", { Phone: [tel] });
      const users = check?.data?.Users || check?.Users || [];
      const isInWhatsapp = users[0]?.IsInWhatsapp === true;

      if (!isInWhatsapp) {
        toast.error("❌ Este número não possui WhatsApp ativo.");
        return; // ❗ NÃO cria contato
      }

      // 🔥 2) Agora sim cria o contato porque é válido
      const { data } = await api.post("/contacts", dados);
      const contatoCriado = data.data;

      toast.success("Contato criado!");

      setModalCriarAberto(false);

      // 🔥 3) Abre atendimento
      await abrirAtendimento(contatoCriado);

    } catch (err) {
      toast.error("Erro ao salvar contato");
    }
  };



  const listaFiltrada = contatos.filter(filtrar);

  return (
    <>
      <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
        <DialogTitle>Selecionar Contato</DialogTitle>

        <DialogContent>
          <TextField
            label="Buscar nome ou telefone"
            fullWidth
            variant="outlined"
            value={filtro}
            onChange={(e) => setFiltro(e.target.value)}
            margin="dense"
          />

          {loading ? (
            <Box display="flex" justifyContent="center" mt={3}>
              <CircularProgress />
            </Box>
          ) : (
            <>
              <List>
                {listaFiltrada.map((c) => (
                  <ListItem
                    button
                    key={c.id}
                    onClick={() => abrirAtendimento(c)}
                  >
                    <ListItemAvatar>
                      <Avatar src={c.photoUrl || ""}>
                        {!c.photoUrl && c.nome?.[0]?.toUpperCase()}
                      </Avatar>
                    </ListItemAvatar>

                    <ListItemText
                      primary={c.nome || "Sem nome"}
                      secondary={c.telefone}
                    />
                  </ListItem>
                ))}

                {!loading && listaFiltrada.length === 0 && (
                  <Box p={2} textAlign="center" color="#666">
                    Nenhum contato encontrado
                  </Box>
                )}
              </List>

              {/* 🔹 Criar novo contato */}
              {listaFiltrada.length === 0 && filtro.trim() !== "" && (
                <Box textAlign="center" mt={2}>
                  <Button
                    variant="contained"
                    color="primary"
                    onClick={abrirCriacaoContato}
                    disabled={abrindo}
                  >
                    Criar contato e abrir atendimento
                  </Button>
                </Box>
              )}
            </>
          )}
        </DialogContent>

        <DialogActions>
          <Button onClick={onClose}>Cancelar</Button>
        </DialogActions>
      </Dialog>

      {/* 🔹 Modal real de criação de contato */}
      <ContactModal
        aberto={modalCriarAberto}
        onFechar={() => setModalCriarAberto(false)}
        contato={novoContato}
        onSalvar={handleSalvarContato}
      />
    </>
  );
}
